import React, { useEffect } from "react";
import AppScreen from "./AppScreen";
import { Link } from "react-router-dom";

const AboutSection = () => {
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <AppScreen>
      <section className="w-11/12 sm:w-8/12 px-8 py-8  my-24 mx-auto bg-white rounded-lg">
        <h1 className="text-center text-2xl sm:text-3xl font-semibold my-10">
          About
        </h1>
        <p className="whitespace-pre-wrap leading-loose text-gray-700">
          <p className="block text-xl my-5 font-semibold">Let’s face it.</p>
          There’s an overwhelming amount of learning resources on the internet,
          but which one should you choose? There’s paid courses, free courses,
          self paced courses, courses with deadlines and assignments, courses on
          almost every possible topic you could possibly be interested in.
          <p className="block text-xl my-5 font-semibold">
            But how do you find the right course?
          </p>
          Yes, you could spend hours googling (or binging or duckduckgoing),
          sifting through the courses based on their ratings, cost, durations,
          only to end up regretting the course that you bought and never going
          through it anyway.
          <p className="block text-xl my-5 font-semibold">
            What if there was an easier way?
          </p>
          <Link
            to={"/"}
            className="text-2xl font-bold bg-gradient-to-br from-indigo-600 to-red-500 bg-clip-text text-transparent"
          >
            Enter Zofium.
          </Link>
          <p className="mt-3">
            Now, in just few clicks, you can find the course you need - with the
            exact specifications that you want,{" "}
            <span className="font-semibold">but without the hassle.</span>
          </p>
        </p>
      </section>
    </AppScreen>
  );
};

export default AboutSection;
